// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  beatSlot: "SectionTaskBundle__beatSlot",
  beatTail: "SectionTaskBundle__beatTail",
  beats: "SectionTaskBundle__beats",
  card: "SectionTaskBundle__card",
  footnote: "SectionTaskBundle__footnote",
  lead: "SectionTaskBundle__lead",
  scrolly: "SectionTaskBundle__scrolly",
  section: "SectionTaskBundle__section",
  stage: "SectionTaskBundle__stage",
  sticky: "SectionTaskBundle__sticky",
};
